/* eslint-disable no-restricted-globals,no-alert,object-curly-newline */
/* global G */
import { bulk, curry } from 'lib/util'
import asObject from 'lib/sequence/component/children/asObject'
import { hide, show } from 'lib/sequence/component/state/hidden'
import { settings } from 'app/_shared/session'
import deviceSearch from 'app/_shared/events/search/device'
import sequenceComponentState from 'lib/sequence/component/state'

const { serialFieldConfig = {} } = settings

const {
  set: setHelperText,
  unset: resetHelperText,
} = sequenceComponentState('helperText')

const {
  set: setError,
} = sequenceComponentState('error')

const bulkHide = bulk(hide)

/**
 * Returns the translation of the text to show when a service item already exists.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {Promise<string>}           the translated string
 */
const invalidSerialNumberText = async module => await module[G.ADAPTER][G.INTL]._t(
  'serialField.invalidSerialNumber',
  {
    ns: 'device',
    _key: 'serialField.invalidSerialNumber',
    defaultValue: 'Invalid serial number',
  },
)

/**
 * If there is a `serialFieldConfig` property in {@link settings} with a truthy `strict` property,
 * checks the regex of its `validator` property against `serial` and returns the result. Otherwise,
 * returns `true`.
 *
 * @param {string} serial string to validate
 * @returns {boolean}
 */
const validate = serial => (serialFieldConfig?.strict
  && serialFieldConfig?.validator
  ? new RegExp(serialFieldConfig.validator).test(serial)
  : true)

/**
 * Event Handler Search Device
 *
 * Attempts to find a service item or equipment by its serial and, depending on what is found, sets
 * the current model's item, equipment and product attributes with their information. Otherwise, if
 * nothing is found, those model attributes are cleared.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Gaia.Component.Spec} component  the current action's main component
 * @param {Gaia.PlatformEvent} event    information about the event that triggered this handler
 * @returns {Promise<[]>}
 */
const searchDeviceAndUpdateField = async (module, component, event) => {
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const { stepper } = asObject(actionComponent[G.CHILDREN])
  const { device } = asObject(stepper[G.CHILDREN])
  const { search: searchTab } = asObject(device[G.CHILDREN])
  const tabState = searchTab[G.STATE]
  const { deviceIdentify } = tabState
  const searchTabChildren = asObject(searchTab[G.CHILDREN])
  const { searchField, list: resultsList, suggestions, newItemList, noItemList } = searchTabChildren
  const { term } = component[G.STATE]?.[G.META] || {}
  const valid = validate(term)
  const itemList = deviceIdentify ? noItemList : newItemList

  bulkHide(resultsList, suggestions, noItemList, newItemList)
  resetHelperText(searchField)
  setError(searchField, false)

  let result = []

  if (term) {
    if (valid) {
      result = await deviceSearch('defaultWithTicketCount', module, component, event)

      result[0]
        ? show(resultsList)
        && bulkHide(suggestions, itemList)
        : show(itemList)
        && bulkHide(resultsList, suggestions)
    } else {
      setHelperText(searchField, await invalidSerialNumberText(module))
      setError(searchField, true)
    }
  }

  module[G.ADAPTER][G.UI].update(module)

  return result
}

export default curry(searchDeviceAndUpdateField)
